import { Request } from "@/api/request";

export class BaseApi {
  /** @param {Object} stores – Pinia‑stores */
  constructor(stores) {
    this.r = Request;
    // проксируем, чтобы внутри модулей обращаться к this.user / this.p2p …
    Object.assign(this, stores);
  }

  /**
   * Единая обёртка для запросов.
   * @param {() => Promise<any>} fn
   * @param {(data:any)=>void} [onOk]
   * @param {Object} [options]
   */
  async request(fn, onOk, options = {}) {
    const res = await fn(options);
    if (res?.ok && onOk) onOk(res.data);
    return res;
  }
}
